import React, { createContext, useContext, useEffect, useState } from "react";
import { useRouteState } from "../../hooks/useRouteState";
import { ROUTE_TYPES } from "../constants/routeConstants";
import { EventsEnum } from "../enums/EventsEnum";

const CustomMeasurementsContext = createContext();

export const useCustomMeasurements = () => {
  const context = useContext(CustomMeasurementsContext);
  if (!context) {
    throw new Error(
      "useCustomMeasurements must be used within CustomMeasurementsProvider"
    );
  }
  return context;
};

export const CustomMeasurementsProvider = ({ children }) => {
  const [customMeasurements, setCustomMeasurements] = useState({});
  const { routeType } = useRouteState();

  const routesForDataCleaning = React.useMemo(
    () => [
      ROUTE_TYPES.PATIENTS,
      ROUTE_TYPES.HOME,
      ROUTE_TYPES.DIGITAL_TWIN,
      ROUTE_TYPES.PATIENT_DASHBOARD,
      ROUTE_TYPES.NOT_FOUND,
    ],
    []
  );

  useEffect(() => {}, [customMeasurements]);

  useEffect(() => {
    const cleanOnRouteChange = () => {
      if (
        routeType &&
        routesForDataCleaning.includes(routeType) &&
        Object.keys(customMeasurements).length > 0
      ) {
        setCustomMeasurements({});
      }
    };
    cleanOnRouteChange();
  }, [customMeasurements, routesForDataCleaning, routeType]);

  useEffect(() => {
    const handleUpdateMeasurement = event => {
      const { measurementId, name, value, support, isCustom, config } =
        event.detail[0];

      if (isCustom) {
        setCustomMeasurements(prev => ({
          ...prev,
          [measurementId]: {
            key: measurementId,
            name,
            value,
            support,
            measurementId,
            config,
          },
        }));
      }
    };

    window.addEventListener(
      EventsEnum.UPDATE_MEASUREMENT,
      handleUpdateMeasurement
    );

    return () => {
      window.removeEventListener(
        EventsEnum.UPDATE_MEASUREMENT,
        handleUpdateMeasurement
      );
    };
  }, []);

  const removeCustomMeasurement = measurementId => {
    setCustomMeasurements(prev => {
      const newMeasurements = { ...prev };
      delete newMeasurements[measurementId];
      return newMeasurements;
    });
  };

  const clearCustomMeasurements = React.useCallback(() => {
    setCustomMeasurements({});
  }, []);

  return (
    <CustomMeasurementsContext.Provider
      value={{
        customMeasurements,
        removeCustomMeasurement,
        clearCustomMeasurements,
      }}
    >
      {children}
    </CustomMeasurementsContext.Provider>
  );
};
